var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.internalString},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }